import { useState } from "react";
import ModuleHeader from "../../components/ModuleHeader";
import usePermission from "../../hooks/usePermission";
import PayoutTab from "./PayoutTab";

const TABS = [
  { key: "inProgress", label: "In Progress" },
  { key: "transferred", label: "Transferred" },
  { key: "hold", label: "Hold" },
];

export default function Payouts() {
  const [activeTab, setActiveTab] = useState("inProgress");
  const { canView } = usePermission("payouts");

  return (
    <div>
      <ModuleHeader
        title="Payouts"
        tabs={TABS}
        activeTab={activeTab}
        onTabChange={setActiveTab}
      />
      <div style={{ padding: 24 }}>
        {canView ? (
          // Remount per tab so each status starts on page 1 with its own state.
          <PayoutTab key={activeTab} status={activeTab} />
        ) : (
          <p style={{ textAlign: "center", color: "#94a3b8" }}>
            You do not have permission to view this module.
          </p>
        )}
      </div>
    </div>
  );
}
